window.dtWorkContractRenewal = function () {
  const dt_work_contract_renewal = new DataTable('#work-contract-renewal-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#work-contract-renewal-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#work-contract-renewal-datatable', 10); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'desc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "code" },
      { "data": "employee_fn" },
      { "data": "employee_ln" },
      { "data": "old_work_contract" },
      { "data": "new_work_contract" },
      { "data": "begin_date" },
      { "data": "end_date" },
    ],
    columnDefs: [],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
      $('td:eq(3)', row).html(`${data.employee_fn} ${data.employee_ln}`);
      $('td:eq(3)', row).attr('colspan', 2);
      $('td:eq(4)', row).remove()
    },
  });

  dtFinalTouch()
}
